"use client";

import React, { useContext, useEffect, useState } from "react";
import { Context } from "../contexts/AppContext";
import { getData, postData, putData } from "../../lib/utils";
import UploadPhoto from "../Gallery/UploadPhoto";

const PhotoHeader = () => {
  const { progress, value } = useContext(Context);
  const [appState, setAppState] = value;

  const { startProgress, updateProgress, stopProgress } = progress;

  const [uploadedBytesTracker, setUploadedBytesTracker] = useState(0);

  // ✅ FIX 1: window.onload ❌ → useEffect ✅
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const url = window.location.pathname;
        const parts = url.split("/");
        const galleryId = parts[parts.indexOf("galleries") + 1];

        const response = await getData(`galleries/gallery/${galleryId}`);

        if (response) {
          const obj = {
            name: response?.folder?.name,
            id: response.folder._id,
            galleries: [response.gallery],
            adminId: response.folder.adminId,
            backgroundMedia: response?.gallery?.backgroundMedia,
          };

          setAppState((prevState) => ({
            ...prevState,
            currentFolderData: obj,
            photoArr: response.photos,
            currentGalleryName: response.gallery.name,
          }));
        }
      } catch (err) {
        console.error("Error fetching gallery:", err);
      }
    };

    fetchGallery();
  }, []);

  // ✅ Progress handler
  const showProgressBar = (fileName, value) => {
    startProgress(fileName);
    updateProgress(value);
  };

  // ✅ FIX 2: Generic handler name (BEST PRACTICE)
  const photoUploadedDone = async (
    fileName,
    fileSizeMB,
    indx,
    totalFiles,
    uniqueId,
    folderName,
  ) => {
    try {

      console.log("CCCCCCCC ",appState?.adminDetails);

      const response = await postData("photos/createPhoto", {
        title: fileName.name,//.split(".")[0],
        folderName:folderName,
        url: `${appState.assetsUrl}/${folderName}/${fileName.name}`,
        galleryId: appState.currentGalleryData._id,
        adminId: appState?.adminDetails.id
      });

      if (!response) return;

      // ✅ update UI
      setAppState((prevState) => ({
        ...prevState,
        photoArr: [...prevState.photoArr, response],
      }));

      stopProgress(uniqueId);

      setAppState((prev) => ({
  ...prev,
  adminDetails: {
    ...prev.adminDetails,
    plan: {
      ...prev.adminDetails.plan,
      currentPhotoCount:
        prev.adminDetails.plan.currentPhotoCount + 1,
    },
  },
}));


      return;

      // ✅ credit calculation
      const newTotal =
        Number(uploadedBytesTracker) + Number(fileSizeMB);

      setUploadedBytesTracker(newTotal);

      const creditObj = {
        credits: newTotal,
        type: "used",
        amount: newTotal,
        purpose: "upload",
      };

      // ✅ update credits
      if (appState?.adminDetails?.id) {
        await putData(
          `admin/update-plan/${appState.adminDetails.id}`,
          creditObj
        );

        // reset tracker
        setUploadedBytesTracker(0);
      }
    } catch (err) {
      console.error("Upload complete error:", err);
    }
  };

  return (
    <div className="border-b border-gray-300 p-4 flex flex-col md:flex-row md:items-center md:justify-between bg-white shadow-sm rounded-md">
      <h2 className="text-lg font-semibold mb-3 md:mb-0">
        {appState?.currentFolderData?.name} |{" "}
        {appState?.currentGalleryName}
      </h2>
       
      <div className="flex items-center gap-4">
        {/* ✅ FIX 3: Correct prop name */}
        <UploadPhoto
          showProgressBar={showProgressBar}
          photoUploadedDone={photoUploadedDone}
        />
      </div>
    </div>
  );
};

export default PhotoHeader;